import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from "query-string";
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import dateformat from 'dateformat';
import { withStyles } from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import { FilterList, CloudOff, Cloud } from "@material-ui/icons";
import Badge from "@material-ui/core/Badge";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withRouter } from 'react-router-dom';
import Pager from "../Pager/Pager";
import SketchOrderStatusChip from "../SketchOrderStatusChip/SketchOrderStatusChip";
import ChooseSketchOrderFilterDialog from "../ChooseSketchOrderFilterDialog";
import StatusSketchOrderFilterDialog from '../StatusSketchOrderFilterDialog';
import OrganizationSketchOrderFilterDialog from "../../containers/OrganizationSketchOrderFilterDialog";
import RequesterSketchOrderFilterDialog from '../../containers/RequesterSketchOrderFilterDialog';
import OwnerSketchOrderFilterDialog from '../../containers/OwnerSketchOrderFilterDialog';

const style = () => ({
    flex: {
        flexGrow: 1,
    },
    listItemTitle: {
        fontWeight: 'bold',
    },
    loadingDialog: {
        width: 30,
        margin: 'auto'
    }
});

class SketchOrderList extends Component {
    state = {
        chooseFilterDialogOpen: false,
        statusFilterDialogOpen: false,
        organizationFilterDialogOpen: false,
        requesterFilterDialogOpen: false,
        ownerFilterDialogOpen: false,
    };

    openFilterSketchOrderDialog = () => {
        this.setState({ chooseFilterDialogOpen: true });
    };

    closeFilterSketchOrderDialog = () => {
        this.setState({ chooseFilterDialogOpen: false });
    };

    applyFilter = (name, value, clearFilters = false) => {
        let newQueryString;
        if (clearFilters) {
            const newQueryParam = {
                [name]: value,
            };
            newQueryString = queryString.stringify(newQueryParam);
        } else {
            const queryParams = queryString.parse(this.props.location.search);
            const newQueryParams = Object.assign({}, queryParams, {
                [name]: value,
            });

            newQueryString = queryString.stringify(newQueryParams);
        }
        this.props.history.push(`${this.props.location.pathname}?${newQueryString}`);
    };

    openStatusFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: false,
            statusFilterDialogOpen: true
        });
    };

    applyStatusFilters = (statuses) => {
        const statusIds = statuses.map((status) => {
            return status.id;
        });

        this.applyFilter('statusIds', statusIds);

        this.closeStatusFilterDialog();
    };

    closeStatusFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: true,
            statusFilterDialogOpen: false
        });
    };

    openOrganizationFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: false,
            organizationFilterDialogOpen: true
        });
    };

    applyOrganizationFilter = (organizationId) => {
        this.applyFilter('organizationId', organizationId);

        this.closeOrganizationFilterDialog();
    };

    closeOrganizationFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: true,
            organizationFilterDialogOpen: false,
        });
    };

    openRequesterFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: false,
            requesterFilterDialogOpen: true
        });
    };

    applyRequesterFilter = (userId) => {
        this.applyFilter('requesterUserId', userId, true);

        this.closeRequesterFilterDialog();
    };

    closeRequesterFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: true,
            requesterFilterDialogOpen: false,
        });
    };

    openOwnerFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: false,
            ownerFilterDialogOpen: true
        });
    };

    applyOwnerFilter = (userId) => {
        this.applyFilter('ownerUserId', userId, true);

        this.closeOwnerFilterDialog();
    };

    closeOwnerFilterDialog = () => {
        this.setState({
            chooseFilterDialogOpen: true,
            ownerFilterDialogOpen: false,
        });
    };

    renderTitle = () => {
        if (this.props.totalOrders === 1)
            return `${this.props.totalOrders} ${this.props.titlePrefix} Sketch Order`;

        return `${this.props.totalOrders} ${this.props.titlePrefix} Sketch Orders`;
    };

    goToOrder = (order) => {
        this.props.history.push(`/orders/${order.id}`);
    };

    renderSketchOrderListItem = id => {
        const order = this.props.sketchOrders[id];
        return (
            <ListItem
                key={order.id}
                button
                onClick={() => this.goToOrder(order)}
            >
                <ListItemText
                    primary={
                        <div>
                            <Typography variant="caption">
                                #{order.id}
                            </Typography>
                            {
                                this.props.showOrganizationName &&
                                <Typography variant="subtitle1" className={this.props.classes.listItemTitle}>
                                    {order.organization.name}
                                </Typography>
                            }
                            <Typography>
                                {order.projectName}
                            </Typography>
                            <Typography>
                                DUE DATE: {order.dueDate}
                            </Typography>
                        </div>
                    }
                    secondary={dateformat(order.requestedDate, 'mmm d, yyyy h:MM TT')}
                />
                {
                    this.props.showStatus &&
                    <SketchOrderStatusChip status={order.sketchOrderStatus} />
                }
            </ListItem>
        );
    }

    determineNumberOfFilersBeingApplied = () => {
        if (this.props.numberOfRequesterFilters) {
            return this.props.numberOfRequesterFilters;
        }

        return this.props.numberOfStatusFilters + this.props.numberOfOrganizationFilters;
    };

    render() {
        const numberOfFiltersApplied = this.determineNumberOfFilersBeingApplied();

        return (
            <div>
                <Paper>
                    <Toolbar>
                        <Typography variant="h6" className={this.props.classes.flex}>
                            {this.renderTitle()}
                        </Typography>
                        {
                            (this.props.canFilter && numberOfFiltersApplied === 0) &&
                            <IconButton onClick={this.openFilterSketchOrderDialog}>
                                <FilterList />
                            </IconButton>
                        }
                        {
                            this.props.filterStorm ?
                            <IconButton onClick={this.props.filterStormClick}>
                                <CloudOff />
                            </IconButton> :
                            <IconButton onClick={this.props.filterStormClick}>
                                <Cloud />
                            </IconButton>
                        }
                        {
                            (this.props.canFilter && numberOfFiltersApplied > 0) &&
                            <IconButton onClick={this.openFilterSketchOrderDialog}>
                                <Badge badgeContent={numberOfFiltersApplied} color="secondary">
                                    <FilterList />
                                </Badge>
                            </IconButton>
                        }
                        <Pager
                            currentPage={this.props.currentPage}
                            totalPages={this.props.totalPages}
                            nextPageClick={this.props.onNextPageClick}
                            prevPageClick={this.props.onPrevPageClick}
                        />
                    </Toolbar>
                    {
                        this.props.isFetching &&
                        <div className={this.props.classes.loadingDialog}>
                            <CircularProgress />
                        </div>
                    }
                    <List>
                        {this.props.sketchOrderIds.map(this.renderSketchOrderListItem)}
                    </List>
                    <Toolbar>
                        <div className={this.props.classes.flex} />
                        <Pager
                            currentPage={this.props.currentPage}
                            totalPages={this.props.totalPages}
                            nextPageClick={this.props.onNextPageClick}
                            prevPageClick={this.props.onPrevPageClick}
                        />
                    </Toolbar>
                </Paper>

                <ChooseSketchOrderFilterDialog
                    open={this.state.chooseFilterDialogOpen}
                    onDismissClick={this.closeFilterSketchOrderDialog}
                    chooseStatusFilter={this.openStatusFilterDialog}
                    numberOfStatusFilters={this.props.numberOfStatusFilters}
                    chooseOrganizationFilter={this.openOrganizationFilterDialog}
                    numberOfOrganizationFilters={this.props.numberOfOrganizationFilters}
                    numberOfRequesterFilters={this.props.numberOfRequesterFilters}
                    numberOfOwnerFilters={this.props.numberOfOwnerFilters}
                    canFilterByOrganization={this.props.canFilterByOrganization}
                    canFilterByRequester={this.props.canFilterByRequester}
                    canFilterByOwner={this.props.canFilterByOwner}
                    chooseRequesterFilter={this.openRequesterFilterDialog}
                    chooseOwnerFilter={this.openOwnerFilterDialog}
                />

                <StatusSketchOrderFilterDialog
                    open={this.state.statusFilterDialogOpen}
                    onApplyClick={this.applyStatusFilters}
                    onDismissClick={this.closeStatusFilterDialog}
                />

                <OrganizationSketchOrderFilterDialog
                    open={this.state.organizationFilterDialogOpen}
                    onApplyClick={this.applyOrganizationFilter}
                    onDismissClick={this.closeOrganizationFilterDialog}
                />

                <RequesterSketchOrderFilterDialog
                    open={this.state.requesterFilterDialogOpen}
                    onApplyClick={this.applyRequesterFilter}
                    onDismissClick={this.closeRequesterFilterDialog}
                />

                <OwnerSketchOrderFilterDialog
                    open={this.state.ownerFilterDialogOpen}
                    onApplyClick={this.applyOwnerFilter}
                    onDismissClick={this.closeOwnerFilterDialog}
                />
            </div>
        )
    }
}

SketchOrderList.propTypes = {
    titlePrefix: PropTypes.string,
    showOrganizationName: PropTypes.bool,
    showStatus: PropTypes.bool,
    canFilter: PropTypes.bool,
    numberOfStatusFilters: PropTypes.number,
    numberOfOrganizationFilters: PropTypes.number,
    numberOfRequesterFilters: PropTypes.number,
    numberOfOwnerFilters: PropTypes.number,
    canFilterByOrganization: PropTypes.bool,
    canFilterByRequester: PropTypes.bool,
    canFilterByOwner: PropTypes.bool,
    sketchOrders: PropTypes.shape({
        sketchOrder: PropTypes.shape({
            id: PropTypes.number.isRequired,
            projectName: PropTypes.string,
            requestedDate: PropTypes.string.isRequired,
            address: PropTypes.string,
            city: PropTypes.string,
            region: PropTypes.string,
            postCode: PropTypes.string,
            country: PropTypes.string,
            dueDate: PropTypes.string,
            sketchOrderStatus: PropTypes.string.isRequired,
            organization: PropTypes.shape({
                name: PropTypes.string.isRequired,
            }).isRequired,
        })
    }).isRequired,
    totalOrders: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onNextPageClick: PropTypes.func.isRequired,
    onPrevPageClick: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    classes: PropTypes.shape({
        flex: PropTypes.string.isRequired,
        listItemTitle: PropTypes.string.isRequired,
        loadingDialog: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string.isRequired,
    }).isRequired,
    filterStormClick: PropTypes.func,
    filterStorm: PropTypes.bool,
    showStormFilter: PropTypes.bool,
};

SketchOrderList.defaultProps = {
    titlePrefix: '',
    showOrganizationName: false,
    showStatus: false,
    canFilter: false,
    numberOfStatusFilters: 0,
    numberOfOrganizationFilters: 0,
    numberOfRequesterFilters: 0,
    numberOfOwnerFilters: 0,
    canFilterByOrganization: false,
    canFilterByRequester: false,
    canFilterByOwner: false,
    filterStorm: false,
    showStormFilter: false,
};

export default withRouter(withStyles(style)(SketchOrderList));